import React from 'react';

export const InsideWindow: Function = (
  props: React.SVGProps<SVGSVGElement>,
): JSX.Element => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      role="presentation"
      viewBox="0 0 95.43 61.79"
      {...props}
    >
      <g id="Group_75" data-name="Group 75">
        <g id="Group_37" data-name="Group 37">
          <g id="Group_615" data-name="Group 615">
            <rect
              id="Rectangle_111"
              data-name="Rectangle 111"
              fill="#fff"
              x="4.86"
              y="0.57"
              width="85.71"
              height="60.66"
            />
            <path
              id="Path_2469"
              data-name="Path 2469"
              fill="#dcd9d5"
              d="M90.57,61.79H4.86a.57.57,0,0,1-.57-.56V.57A.57.57,0,0,1,4.86,0H90.57a.56.56,0,0,1,.57.57h0V61.23A.56.56,0,0,1,90.57,61.79ZM5.43,60.66H90V1.14H5.43Z"
            />
          </g>
          <g id="Group_616" data-name="Group 616">
            <rect
              id="Rectangle_112"
              data-name="Rectangle 112"
              fill="#fff"
              x="4.86"
              y="0.57"
              width="85.71"
              height="60.66"
            />
            <path
              id="Path_2470"
              data-name="Path 2470"
              fill="#dcd9d5"
              d="M90.57,61.79H4.86a.57.57,0,0,1-.57-.56V.57A.57.57,0,0,1,4.86,0H90.57a.56.56,0,0,1,.57.57h0V61.23A.56.56,0,0,1,90.57,61.79ZM5.43,60.66H90V1.14H5.43Z"
            />
          </g>
          <g id="Group_617" data-name="Group 617">
            <rect
              id="Rectangle_113"
              data-name="Rectangle 113"
              fill="#dcd9d5"
              x="8.86"
              y="4.57"
              width="77.71"
              height="52.66"
            />
            <path
              id="Path_2471"
              data-name="Path 2471"
              fill="#dcd9d5"
              d="M86.57,57.79H8.86a.57.57,0,0,1-.57-.56V4.57A.57.57,0,0,1,8.86,4H86.57a.56.56,0,0,1,.57.57h0V57.23A.56.56,0,0,1,86.57,57.79ZM9.43,56.66H86V5.13H9.43Z"
            />
          </g>
          <path
            id="Path_2472"
            data-name="Path 2472"
            fill="#dcd9d5"
            d="M94.9,61.76H.54A.54.54,0,0,1,0,61.23H0a.54.54,0,0,1,.54-.54H94.9a.54.54,0,0,1,.53.54h0A.53.53,0,0,1,94.9,61.76Z"
          />
        </g>
      </g>
      <rect fill="#27375f" x="8.07" y="3.39" width="79.03" height="3.27" />
      <path
        fill="#fff"
        d="M86.88,3.61V6.44H8.29V3.61H86.88m.44-.44H7.85V6.89H87.32V3.17Z"
      />
      <rect fill="#27375f" x="8.01" y="36.24" width="79.16" height="1.73" />
      <path
        fill="#fff"
        d="M87,36.39v1.42H8.16V36.39H87m.31-.31H7.85v2H87.32v-2Z"
      />
      <rect fill="#27375f" x="8.07" y="6.87" width="79.03" height="2.7" />
      <path
        fill="#fff"
        d="M86.88,7.09V9.34H8.29V7.09H86.88m.44-.44H7.85V9.78H87.32V6.65Z"
      />
      <polygon
        fill="#27375f"
        points="8.11 12.6 8.07 9.9 87.1 9.9 87.1 12.6 8.11 12.6"
      />
      <path
        fill="#fff"
        d="M86.88,10.12v2.26H8.32l0-2.26H86.88m.44-.44H7.85v.45l0,2.26v.43H87.32V9.68Z"
      />
      <rect fill="#27375f" x="8.07" y="12.71" width="79.03" height="2.7" />
      <path
        fill="#fff"
        d="M86.88,12.93v2.25H8.29V12.93H86.88m.44-.44H7.85v3.13H87.32V12.49Z"
      />
      <polygon
        fill="#27375f"
        points="8.11 18.44 8.07 15.74 87.1 15.74 87.1 18.44 8.11 18.44"
      />
      <path
        fill="#fff"
        d="M86.88,16v2.26H8.32l0-2.26H86.88m.44-.44H7.85V16l0,2.25v.44H87.32V15.52Z"
      />
      <rect fill="#27375f" x="8.07" y="18.61" width="79.03" height="2.7" />
      <path
        fill="#fff"
        d="M86.88,18.83v2.25H8.29V18.83H86.88m.44-.44H7.85v3.13H87.32V18.39Z"
      />
      <polygon
        fill="#27375f"
        points="8.11 24.34 8.07 21.64 87.1 21.64 87.1 24.34 8.11 24.34"
      />
      <path
        fill="#fff"
        d="M86.88,21.86v2.26H8.32l0-2.26H86.88m.44-.44H7.85v.45l0,2.25v.44H87.32V21.42Z"
      />
      <rect fill="#27375f" x="8.07" y="24.45" width="79.03" height="2.7" />
      <path
        fill="#fff"
        d="M86.88,24.67v2.25H8.29V24.67H86.88m.44-.44H7.85v3.13H87.32V24.23Z"
      />
      <polygon
        fill="#27375f"
        points="8.11 30.18 8.07 27.48 87.1 27.48 87.1 30.18 8.11 30.18"
      />
      <path
        fill="#fff"
        d="M86.88,27.7V30H8.32l0-2.26H86.88m.44-.44H7.85v.45l0,2.25v.44H87.32V27.26Z"
      />
      <rect fill="#27375f" x="8.07" y="30.17" width="79.03" height="2.7" />
      <path
        fill="#fff"
        d="M86.88,30.39v2.26H8.29V30.39H86.88m.44-.44H7.85v3.13H87.32V30Z"
      />
      <polygon
        fill="#27375f"
        points="8.11 35.9 8.07 33.2 87.1 33.2 87.1 35.9 8.11 35.9"
      />
      <path
        fill="#fff"
        d="M86.88,33.42v2.26H8.32l0-2.26H86.88m.44-.44H7.85v.45l0,2.26v.43H87.32V33Z"
      />
    </svg>
  );
};
